import { generateTestId } from '@vs/functions/generate-test-id';
import { useTranslation } from 'react-i18next';

import { testIdName } from './constants';
import { AppData } from './type';

export function AppButton({ name, Icon, href }: AppData) {
  const { t } = useTranslation(['shared']);
  const content = (
    <div
      className="aspect-square rounded-lg cursor-pointer hover:bg-vs-base-300 transition-colors py-2 flex flex-col items-center justify-between"
      {...(href ? {} : { style: { flex: '0 1 33.33%' } })}
    >
      <div className="p-2 aspect-square flex items-start justify-center mb-1 bg-white rounded-lg">
        <Icon className="text-[40px]" />
      </div>
      <div className="vs-label-xs-regular text-vs-base-content">
        {t(`apps_panel.app.${name}`)}
      </div>
    </div>
  );
  return href ? (
    <a
      {...generateTestId('btn-like', [testIdName, name])}
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{ flex: '0 1 33.33%' }}
    >
      {content}
    </a>
  ) : (
    content
  );
}
